import Moment from 'moment';
import { get } from '..';

interface GetTicketStatsParams {
  buildingId: string;
  from?: string;
  to?: string;
}

const getTicketStats = ({
  buildingId,
  from = Moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
  to = Moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
}: GetTicketStatsParams) => {
  let url: string = `metrics/ticket/statistics?buildingId=${buildingId}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  return get(url);
};

export default getTicketStats;
